import $ from 'jquery';
import EventBus from '../../common/EventBus';

const TIMING = {
  searchDebounce: 300,        // milliseconds
  logSearchDebounce: 3000,    // milliseconds
  minSearchLength: 2,         // minimum characters
};

// Helper to safely track search events
const trackSearchAnalytics = (event, properties) => {
  if (typeof _kmq !== 'undefined') {
    _kmq.push(['record', event, properties]);
  }
};

export default class WorkSearch {
  constructor() {
    this.searchResults = $('.search-results');
    this.lastSearch = '';
    this.savedSearchRequest = null;
    this.search = $.debounce(TIMING.searchDebounce, this._onSearchInput.bind(this));
    this.logSearch = $.debounce(TIMING.logSearchDebounce, this._logSearchEvent.bind(this));
    this.init();
  }

  init() {
    $('.booking-work-search').on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    $('.booking-work-search input')
      .on('keyup', (e) => this.search(e))
      .on('keypress', (e) => this.search(e));
  }

  showResults(resultsHtml) {
    this.searchResults.filter('#v2-search-results').html(resultsHtml);
    this.searchResults.find('.js-add-work-item-btn').on('click tap', window.Application.FacebookPixel.add_to_cart);
    this.searchResults.trigger('begin-search-state');
    EventBus.emit('search:started', { results: resultsHtml });
    this.searchResults.removeClass('hidden');
  }

  hideResults() {
    this.searchResults.trigger('end-search-state');
    EventBus.emit('search:ended', {});
    this.searchResults.addClass('hidden');
  }

  _onSearchInput(e) {
    const value = $.trim($(e.target).val());
    if (value.length < TIMING.minSearchLength) {
      return;
    }
    if (this.searchResults.is(':visible') && value === this.lastSearch) {
      return;
    }
    if (window.request_in_progress && this.savedSearchRequest) {
      this.savedSearchRequest.abort();
    } // request in progress goes via controller and js.erb

    this.lastSearch = value;
    this.savedSearchRequest = $.get($(e.target).parents('form').attr('action'), $(e.target).parents('form').serialize());
    $('.js-work-section').addClass('hidden');
    $('.loading-search-results').removeClass('hidden');
    this.searchResults.addClass('hidden');
    this.logSearch(value);
    window.request_in_progress = true;
  }

  _logSearchEvent(query) {
    trackSearchAnalytics('Search query entered', {
      query: query,
      result_count: window.Application.search_result_count,
      top_results: window.Application.top_search_results,
    });
  }
}
